import React, { useEffect, useState } from "react";
import { Formik, FormikProvider, useFormik, Form, Field, FieldArray, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Modal, Row, Col, Button } from "react-bootstrap";
import { VscDiffAdded } from "react-icons/vsc";
import { BiTrash } from "react-icons/bi";
import CommonFormHeading from "../CommonUtils/CommonFormHeading";
import { ImagePdfBucket } from "../CommonUtils/ImagesBase64";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { failureAlert, successAlertRefresh } from "../CommonUtils/SweetAlerts";
import { config } from "../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { viewImage } from "../CommonUtils/viewImage";
import { allowAlphabetAndSpacesOnly } from "../CommonUtils/CommonValidations";
import { FaEdit, FaEye, FaTrash } from "react-icons/fa";
import { successAlert2 } from "../CommonUtils/SweetAlerts";

// ---- Validation schema ----
const validationSchema = Yup.object().shape({
  keyPeopleEntryList: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Name is required"),
      designation: Yup.string().required("Designation is required"),
      displaydesignation: Yup.string().required("Designation is required"),
      uploadFile: Yup.mixed().required("File is required"),
    }),
  ),
});

const DESIGNATION_OPTIONS = [
  { value: "honble_chairman", label: "Hon'ble Chairman" },
  { value: "special_chief_secretary", label: "Hon'ble Minister" },
];

export default function AddKeyPeople() {
  const [showModal, setShowModal] = useState(false);
  const [keyPeople, setKeyPeople] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [editDesignation, setEditDesignation] = useState(null);

  const formik = useFormik({
    initialValues: {
      keyPeopleEntryList: [
        {
          name: "",
          designation: "",
          uploadFile: "",
          displaydesignation: "",
          displayOrder: '',
        },
      ],
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      const sno = values?.keyPeopleEntryList?.[0]?.sno;
      Swal.fire({
        text: `Are you sure you want to ${isEdit ? "update" : "submit"}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: `Yes, ${isEdit ? "update" : "submit"} it!`,
        cancelButtonText: "No, cancel!",
        backdrop: false,
      }).then((result) => {
        if (result.isConfirmed) {
          let url;
          let payload = {
            ...values,
            keyPeopleEntryList: values.keyPeopleEntryList.map((item) => ({
              ...item,
              displayOrder: item.designation === "honble_chairman" ? 3 : item.designation === "special_chief_secretary" ? 2 : 1,
            })),
          }
          if (isEdit) {
            url = `${config.url.STU_URL}updateKeyPeopleData/${sno}`;
          } else {
            url = `${config.url.STU_URL}saveKeyPeopleData`;
          }

          CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
              successAlertRefresh(res?.data?.sdesc);
              resetForm();
              setShowModal(false);
              setIsEdit(false);
              setEditDesignation(null);
              GetKeyPeopleData();
            } else {
              failureAlert(res?.data?.sdesc);
            }
          });
        } else {
          console.log("Submission canceled");
        }
      });
    },
  });

  // ---- Fetch Key People Data ----
  function GetKeyPeopleData() {
    let url = config.url.STU_URL + `ov-public/getKeyPeopleData`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01") {
        setKeyPeople(res?.data?.data);
      } else {
        setKeyPeople([]);
      }
    });
  }


  useEffect(() => {
    GetKeyPeopleData();
  }, []);

  const handleOpenModal = () => {
    setIsEdit(false);
    setEditDesignation(null);
    formik.resetForm();
    setShowModal(true);
  };
  const handleCloseModal = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditDesignation(null);
    setShowModal(false);
  };
  const handleEdit = (item) => {
    setIsEdit(true);
    setEditDesignation(item.designation);
    formik.setValues({
      keyPeopleEntryList: [
        {
          name: item.name || "",
          designation: item.designation || "",
          uploadFile: item.upload_file || "",
          displaydesignation: item?.display_designation || '',
          sno: item?.sno,
        },
      ],
    });
    setShowModal(true);
  };

  const handleDelete = (designation) => {
    Swal.fire({
      title: "Delete Key People",
      text: "Are you sure you want to delete this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      backdrop: false,
    }).then((result) => {
      if (result.isConfirmed) {
        let url = config.url.STU_URL + `deleteKeyPeopleData/${designation}`;
        CommonAxiosPost(url).then((res) => {
          if (res?.data?.scode === "01") {
            successAlert2(res?.data?.sdesc);
            GetKeyPeopleData();
          } else {
            failureAlert(res?.data?.sdesc);
          }
        });
      }
    });
  };

  // Designation mapping - Value to Label
  const designationMap = {
    honble_chairman: "Hon'ble Chairman",
    special_chief_secretary: "Hon'ble Minister",
    managing_director: "Managing Director",
  };

  return (
    <div className="affl-newdiv">
      <div className="container-fluid px-1">
        <CommonFormHeading heading="Key People" />
        {/* <div className="row mb-3">
          <div className="col-12">
            <Row>
              <Col xs={12} sm={12} md={12} lg={10} xl={10} xxl={10} />
              <Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <div className="d-flex flex-row justify-content-end">
                  <Button type="button" size="sm" variant="primary" onClick={handleOpenModal}>
                    + Add Key People
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div> */}
        {keyPeople?.length > 0 && (
          <div className="table-responsive">
            <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Description</th>
                  <th>Image</th>
                  <th className="text-center">Edit </th>
                </tr>
              </thead>
              <tbody>
                {/* {keyPeople.map((item, index) => ( */}
                {keyPeople
                  .filter(item => item.designation?.trim())
                  .map((item, index) => (
                    <tr key={index}>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.name || "-"}</td>
                      <td>{designationMap[item.designation] || "-"}</td>
                      <td>{item.display_designation || "-"}</td>
                      <td className="text-center">
                        {item.upload_file ? (
                          <button className="btn btn-sm btn-success">
                            <FaEye onClick={() => viewImage(item.upload_file)} title="View PDF" />
                          </button>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="text-center">
                        <button className="btn btn-sm btn-primary me-2">
                          <FaEdit onClick={() => handleEdit(item)} />
                        </button>
                        {/* <button className="btn btn-danger btn-sm">
                          <FaTrash onClick={() => handleDelete(item.designation)} />
                        </button> */}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}

        <Modal show={showModal} onHide={handleCloseModal} size="lg" centered className="inner-modalnew">
          <Modal.Header closeButton>
            <Modal.Title>{isEdit ? "Edit Key People" : "Add Key People"}</Modal.Title>
          </Modal.Header>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Modal.Body>
                <div className="table-responsive">
                  <table className="table table-condensed table-bordered table-sm affl-table">
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Designation</th>
                        <th>Name</th>
                        <th>Description </th>
                        <th>Upload File</th>
                        {!isEdit && <th>Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      <FieldArray name="keyPeopleEntryList">
                        {({ push, remove }) => (
                          <>
                            {formik.values.keyPeopleEntryList.map((detail, index) => (
                              <tr key={index}>
                                <td>
                                  <center>{index + 1}</center>
                                </td>

                                <td>
                                  {/* {isEdit ? (
                                    <div>
                                      <Field as="select" className="form-control" name={`keyPeopleEntryList[${index}].designation`} disabled={isEdit}>
                                        <option value="">-----Select-----</option>
                                        {DESIGNATION_OPTIONS.map((option) => (
                                          <option key={option.value} value={option.value}>
                                            {option.label}
                                          </option>
                                        ))}
                                      </Field>
                                      <small className="text-muted">* Designation cannot be changed</small>
                                    </div>
                                  ) : ( */}
                                  <Field as="select" className="form-control" name={`keyPeopleEntryList[${index}].designation`} disabled >
                                    <option value="">-----Select-----</option>
                                    {DESIGNATION_OPTIONS.filter((option) => {
                                      const selectedInOtherRows = formik.values.keyPeopleEntryList
                                        .filter((_, idx) => idx !== index)
                                        .map((item) => item.designation)
                                        .filter((d) => d && d !== "");

                                      return !selectedInOtherRows.includes(option.value);
                                    }).map((option) => (
                                      <option key={option.value} value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </Field>
                                  {/* )} */}
                                  <ErrorMessage name={`keyPeopleEntryList[${index}].designation`} component="div" className="text-error" />
                                </td>



                                <td>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    name={`keyPeopleEntryList[${index}].name`}
                                    placeholder="Enter name"
                                    // onKeyPress={(e) => {
                                    //   allowAlphabetAndSpacesOnly(e);
                                    // }}
                                    maxLength="100"
                                  />
                                  <ErrorMessage name={`keyPeopleEntryList[${index}].name`} component="div" className="text-error" />
                                </td>
                                <td>
                                  <Field
                                    as="textarea"
                                    className="form-control"
                                    name={`keyPeopleEntryList[${index}].displaydesignation`}
                                    placeholder="Enter "
                                    onKeyPress={(e) => {
                                      allowAlphabetAndSpacesOnly(e);
                                    }}
                                    maxLength="300"
                                  />
                                  <ErrorMessage name={`keyPeopleEntryList[${index}].displaydesignation`} component="div" className="text-error" />
                                </td>
                                <td>
                                  {isEdit && detail.uploadFile && typeof detail.uploadFile === "string" && (
                                    <div className="mb-2">
                                      <span
                                        className="text-primary text-decoration-underline"
                                        style={{ cursor: "pointer" }}
                                        role="button"
                                        tabIndex={0}
                                        onClick={() => viewImage(detail.uploadFile)}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter" || e.key === " ") {
                                            e.preventDefault();
                                            viewImage(detail.uploadFile);
                                          }
                                        }}
                                      >
                                        View Existing Image
                                      </span>
                                    </div>
                                  )}
                                  <input
                                    type="file"
                                    className="form-control mt-3 mb-2"
                                    accept="image/*"
                                    name={`keyPeopleEntryList[${index}].uploadFile`}
                                    onChange={(e) => {
                                      const fieldName = `keyPeopleEntryList[${index}].uploadFile`;
                                      const fileName = `${Date.now()}_key_${index}`;
                                      const path = "/Uploads/keyFile/";
                                      ImagePdfBucket(e, formik, path, fieldName, fileName, "image");
                                    }}
                                  />
                                  <ErrorMessage name={`keyPeopleEntryList[${index}].uploadFile`} component="div" className="text-error" />
                                </td>
                                {!isEdit && (
                                  <td align="center">
                                    {index === 0 && formik.values.keyPeopleEntryList.length < 2 && (
                                      <button type="button" className="button-title btn btn-sm btn-success" onClick={() => push({ name: "", designation: "", uploadFile: "", displaydesignation: "" })}>
                                        <VscDiffAdded />
                                      </button>
                                    )}
                                    {index >= 1 && (
                                      <button type="button" className="button-title btn btn-sm btn-danger" onClick={() => remove(index)}>
                                        <BiTrash />
                                      </button>
                                    )}
                                  </td>
                                )}
                              </tr>
                            ))}
                          </>
                        )}
                      </FieldArray>
                    </tbody>
                  </table>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" size="sm" onClick={handleCloseModal}>
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="success"
                  size="sm"
                  onClick={() => {
                    console.log("Button clicked");
                    console.log(formik.errors);
                  }}
                >
                  {isEdit ? "Update" : "Submit"}
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal>
      </div>
    </div>
  );
}
